
import { Button } from "@/components/ui/button";

interface EpisodesEmptyStateProps {
  searchTerm: string;
  selectedCategory: string | null;
  setSearchTerm: (term: string) => void;
  setSelectedCategory: (categoryId: string | null) => void;
}

const EpisodesEmptyState = ({
  searchTerm,
  selectedCategory,
  setSearchTerm,
  setSelectedCategory,
}: EpisodesEmptyStateProps) => {
  return (
    <div className="text-center py-20">
      <p className="text-2xl text-gray-600 mb-6">
        {searchTerm || selectedCategory ? "No episodes found matching your filters." : "No episodes available yet."}
      </p>
      {(searchTerm || selectedCategory) && (
        <div className="space-x-4">
          {searchTerm && (
            <Button onClick={() => setSearchTerm("")} className="bg-teedee-blue hover:bg-teedee-blue/90 text-lg px-8 py-4">
              Clear Search
            </Button>
          )}
          {selectedCategory && (
            <Button onClick={() => setSelectedCategory(null)} variant="outline" className="border-teedee-blue text-teedee-blue hover:bg-teedee-blue hover:text-white text-lg px-8 py-4">
              Clear Category Filter
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EpisodesEmptyState;
